import { render } from "./AddUritus.vue?vue&type=template&id=333ff431&scoped=true"
import script from "./AddUritus.vue?vue&type=script&lang=js"
export * from "./AddUritus.vue?vue&type=script&lang=js"

import "./AddUritus.vue?vue&type=style&index=0&id=333ff431&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-333ff431"]])

export default __exports__